import type RecursiveReadOnly from "owa-service/lib/RecursiveReadOnly";
import type UserOptionsType from "owa-service/lib/contract/UserOptionsType";
import getUserConfiguration from "../actions/getUserConfiguration";

export default (): RecursiveReadOnly<UserOptionsType | undefined> => getUserConfiguration().UserOptions;
